import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { SITE_LANGUAGES, STORAGE_KEY } from 'src/app/shared/constants';
import { CoreService } from 'src/app/services/core.service';

type SiteLanguage = (typeof SITE_LANGUAGES)[number];
type LanguageDropdownAppearance = 'default' | 'landing' | 'login' | 'admin';

@Component({
  selector: 'app-language-dropdown',
  imports: [MaterialModule, TranslateModule],
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
  host: {
    '[class.landing-style]': "appearance === 'landing'",
    '[class.login-style]': "appearance === 'login'",
    '[class.admin-style]': "appearance === 'admin'"
  }
})
export class LanguageDropdownComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  private readonly coreService = inject(CoreService);
  @Input() appearance: LanguageDropdownAppearance = 'default';
  readonly languages = SITE_LANGUAGES;
  selectedLanguage: SiteLanguage;

  ngOnInit() {
    this.selectedLanguage = this.coreService.getUserLanguage();
  }

  get showLanguageName(): boolean {
    return this.appearance === 'login' || this.appearance === 'admin';
  }

  get menuPanelClass(): string {
    if (this.appearance === 'admin') return 'admin-language-menu';
    if (this.appearance === 'login') return 'cardWithShadow login-language-menu';
    return 'cardWithShadow';
  }

  changeLanguage(lang: SiteLanguage) {
    this.translateService.use(lang.code);
    localStorage.setItem(STORAGE_KEY.USER_LANGUAGE, lang.code);
    this.selectedLanguage = lang;
  }
}
